import { styled } from '@material-ui/core';

export const Container = styled('div')({});

export const ContentBody = styled('p')(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: '14px',
}));

export const ContentSubHeading = styled('h3')(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: '16px',
  fontWeight: 'bold',
  padding: '15px 0px 10px 0px',
}));

export const HrBreak = styled('hr')({
  borderRadius: '6px',
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  margin: '0px -15px 0px -15px',
});

export const ContentUnorderedList = styled('ul')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.common.black,
}));

export const ContentOrderedList = styled('ol')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.common.black,
}));
